import React, { useMemo } from "react";

import { ReactFlowProvider } from "react-flow-renderer";

import { Typography } from "clearsense-ui/components";

import { getGraph } from "./data";

import Graph from "../../Graph";

const GraphContainer = ({
  jobDetails,
  modelGraph,
  setSelectedNode,
  modelGraphNodeMap,
}) => {
  const initialGraphSchema = useMemo(
    () => getGraph(jobDetails, modelGraph.model_graph, modelGraphNodeMap),
    [jobDetails, modelGraph]
  );

  if (!initialGraphSchema) {
    return (
      <div className="min-h-[400px]">
        <Typography>Failed to Load data</Typography>
      </div>
    );
  }

  return (
    <div className="h-[calc(100vh-250px)]">
      <ReactFlowProvider>
        <Graph {...initialGraphSchema} setSelectedNode={setSelectedNode} />
      </ReactFlowProvider>
    </div>
  );
};

export default GraphContainer;
